const $ = require("jquery");

const AnimationAlmostInView = {

  init() {
    const $items = $('.e-animate--fadein-left, .e-animate--fadein-right, .e-animate--fadein-up, .e-animate--fadein-down');
    if ( $items.length > 0 ) {
      this.setup();
    }
  },
  setup() {
    const elements = document.querySelectorAll('.e-animate--fadein-left, .e-animate--fadein-right, .e-animate--fadein-up, .e-animate--fadein-down');

    const observer = new IntersectionObserver(entries => {
      
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('e-animate--active');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0 // 0.1 trigger when 10% of element is in view
      //rootMargin: "0px 0px -8% 0px" // show elements when 15% up from the bottom of the viewport
    });

    elements.forEach(element => {
      observer.observe(element); // observe each element
    });


    window.addEventListener('DOMContentLoaded', (event) => {

      const sections = Array.from(document.querySelectorAll('.e-animate--fadein-left, .e-animate--fadein-right, .e-animate--fadein-up, .e-animate--fadein-down'));
      
      for (let section of sections) {
        observer.observe(section);
      }
      
    });

  }
};
$(AnimationAlmostInView.init.bind(AnimationAlmostInView));
